export enum FuelTankFraction {
    Quarter = 'Quarter',
    Half = 'Half',
    Third = 'Third',
    Full = 'Full'
}
